export default "__VITE_ASSET__COUAfWSM__"